// removed by extract-text-webpack-plugin
module.exports = {"authPopover":"_1rmhA","openButton":"_2-sdr","open":"_1-Hxi","noStore":"zKhwa","popoverBody":"_1bohh","poweredBy":"_1mAfP","contactInfo":"dk6s5","name":"_2wFM3","email":"_3VHkK","links":"_3TfvT"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AuthPopover/index.sass
// module id = 1461
// module chunks = 1